module.exports = __webpack_public_path__ + "static/media/logo_coca_cola.b888e1da.png";